import { Loader2Icon } from 'lucide-react'

import { cn } from '@/lib/utils'

interface RouteFallbackProps {
  fullScreen?: boolean
}

export function RouteFallback({ fullScreen = false }: RouteFallbackProps) {
  return (
    <div
      className={cn(
        'flex w-full items-center justify-center',
        fullScreen ? 'h-dvh' : 'h-full',
      )}
    >
      <Loader2Icon className="size-6 animate-spin text-muted-foreground" />
    </div>
  )
}
